<template>
    <div id="app" style="position:relative;">
        {{isAuthed}}
        <navbar></navbar>
        <download-manager v-if="authed"></download-manager>
        <div class="layout" :class="[routeName, {'full-width': expanded === true || expanded === 'true'}]">
            <div class="component widgets" :class="{ 'hidden': isHidden }">
                <sidebar v-if="authed"></sidebar>
                <widgets v-if="authed"></widgets>
            </div>
            <main class="component main clearfix">
                <div v-if="loading" class="overlay">
                    <loader></loader>
                </div>
                <router-view :key="routerViewKey"></router-view>                
            </main>

        </div>
    </div>
</template>

<script>
    import Navbar from './components/Navbar'
    import Sidebar from './components/Sidebar'
    import Widgets from './components/Widgets'
    import Loader from './components/widgets/Loader.vue';    
    import DownloadManager from './components/reusable/download-manager/DownloadManager.vue';
    
    // import Intercom from './components/reusable/intercom/Intercom.vue'

    export default {
        data() {
            return {
                authed:false,
                expanded: false,
                routeName: null,
            }
        },
        mounted() {
            var self = this;
            this.routeName = this.$route.name;
            this.expanded = this.$route.query.expanded;
            self.$bus.$on('login', function() {
                self.authed = true;
            });
            self.$bus.$on('logout', function() {
                self.authed = false;
            });
        },
        watch: {
            '$route.query.expanded'() {
                this.expanded = this.$route.query.expanded;
            },
        },
        components: { Navbar, Sidebar, Widgets, Loader, DownloadManager },
        computed: {
            isHidden() {
                return this.$route.name === 'courseAdmin';
            },
            loading() {
                // return true;
                return this.$store.getters.loading;
            },
            isAuthed() {
                localStorage.getItem('account_id') ? this.authed = true : this.authed = false;
            },
            isProd() {
                return window.location.hostname === 'portal.tttc.ca';
            },

            /**
             * By default, Vue components are re-used if possible. This means
             * that changing a parameter in the URL doesn't run through the same
             * lifecycle hooks as you would expect from a fresh load.
             *
             * The recommend approach is to watch changing parameter with a
             * `$route.params.myParam` watcher; THIS SHOULD BE TRIED FIRST.
             * However, if your view is complicated, it may be easier to load it
             * fresh to avoid introducing bugs by refactoring your code to
             * support the recommended approach.
             *
             * That's what this property allows us to do. Add any routes where
             * you'd like to use the auto-refresh behavior to the
             * `refreshRouteNames` array.
             */
            routerViewKey() {
                const refreshRouteNames = [
                    'forum-post',
                    'forum-thread',
                    'KB Article',
                    'thread',
                    'galleries',
                    'student'
                ];
                function isRefreshRoute(r) {
                    return !!refreshRouteNames.find(n => r.name === n);
                }
                if (isRefreshRoute(this.$route)) {
                    return this.$route.fullPath;
                } else {
                    return null;
                }
            },
        }
    }
</script>
<style lang="css">
    #app {
        min-width:1024px;
        overflow-x: auto!important;
    }
    .form-control:not([type="file"]) {
        border: none!important;
        border-bottom: 1px solid #fff!important;
        border-radius: 0!important;
        padding-left:0.5rem!important;
        background:transparent!important;
    }

    .overlay .v-spinner .v-ring {
        width:150px!important;
        height:150px!important;
    }

    .overlay .v-spinner {
        .v-ring2 {
            border:8px solid #33ccff!important;
            opacity:0.4!important;
        }
        .v-ring3 {
            border:8px solid #33ccff!important;
            opacity:.6!important;
        }

    }

    body #toast-container > .toast-info {
      background-image: none!important;
    }

</style>
<style lang="scss" scoped>
    .branch-name {
        position: fixed;
        z-index: 9999999999;
        top:0;
        left:0;
        display: inline-block;
    }
    main {
        position:relative;
    }
    .overlay {
        width:100%;
        height:100%;
        position: absolute;
        top:0;
        left:0;
        //background: rgba(50,50,50,.95);
        background: #0F0F0F;
        z-index:9999995;
    }

    .layout {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-around;
        align-content: space-around;
        align-items: flex-start;
        max-width:1366px;
        margin:0 auto;
        float:none;
        transition:max-width 1s;
        &.full-width {
            max-width:100%;
        }
        // @media screen and (max-width:1023px) {
        //       flex-direction: column;
        // }
    }
    .component:nth-child(1) {
        order: 0;
        flex: 0 1 auto;
        align-self: auto;
        //padding: 0 2rem;
        max-width:320px;
        // @media screen and (max-width:1023px) {
        //     max-width:100%;
        //     width:100%;
        //     order:1;
        // }
    }

    .main {
        max-width:100%;
        overflow: hidden;
    }
    .component:nth-child(2) {
        order: 0;
        flex: 2 1 auto;
        align-self: auto;
        //padding:0 3rem;
        // @media screen and (max-width:1023px) {
        //     flex: 0 1 auto;
        //     order:0;
        // }
    }
    
    // .component:nth-child(3) {
    //     order: 0;
    //     flex: 0 1 auto;
    //     align-self: auto;
    //     }
    //   .main {
    //     padding: 0;
    //   }
</style>
<style lang="scss">

    // Bootstrap
    $icon-font-path: '../node_modules/bootstrap-sass/assets/fonts/bootstrap/';
    $link-color: #42b983;
    $brand-success: #42b983;
    @import "assets/scss/variables";
    @import 'node_modules/bootstrap-sass/assets/stylesheets/bootstrap';
    @import "node_modules/bootswatch/darkly/bootswatch";

    @import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");
    // font awesome
    $fa-font-path: '../node_modules/font-awesome/fonts/';
    @import 'node_modules/font-awesome/scss/font-awesome';

    @import "assets/scss/style";

</style>



// WEBPACK FOOTER //
// App.vue?6dc4951f